import { render } from "./MedicoCreate.vue?vue&type=template&id=0a912f35&scoped=true"
import script from "./MedicoCreate.vue?vue&type=script&lang=js"
export * from "./MedicoCreate.vue?vue&type=script&lang=js"

import "./MedicoCreate.vue?vue&type=style&index=0&id=0a912f35&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a912f35"]])

export default __exports__